export enum FieldType {
	Text = 'Text',
	Select = 'Select'
}

export enum CustomFieldType {
	Video = 'Video',
	Registration = 'Registration'
}
